export default __webpack_public_path__ + "static/scissors-edd23cd2f9a7aab17fefcbbc7ff7725e.png";